// Bourbon "Tropik Crest": volcano peak + lagoon wave + star
export const LogoMark = ({ className = 'h-9 w-9', ...props }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" {...props}>
    <rect width="64" height="64" rx="18" fill="hsl(var(--primary))" />
    <path d="M14 46 L32 16 L50 46 Z" fill="#fff" />
    <path d="M12 46 C18 38 24 38 30 43 C35 47 40 47 44 42 C47 39 50 40 53 46 Z" fill="hsl(var(--secondary))" />
    <path d="M32 6.5 l1.9 4 4.4 .5 -3.2 3 .9 4.3 -4 -2.2 -4 2.2 .9 -4.3 -3.2 -3 4.4 -.5z" fill="hsl(var(--gold))" />
  </svg>
);

export const Logo = ({ size = 'md', withText = true, className = '' }) => {
  const mark = size === 'lg' ? 'h-12 w-12' : size === 'sm' ? 'h-7 w-7' : 'h-9 w-9';
  const text = size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-lg' : 'text-xl';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark className={`${mark} logo-animate drop-shadow-sm`} />
      {withText && <span className={`font-display font-extrabold tracking-tight ${text}`}>Bourbon</span>}
    </span>
  );
};
